import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import EditIcon from "@material-ui/icons/Edit";
import DeleteModal from "../../ui/DeleteModal";
import { useDispatch, useSelector } from "react-redux";
import {
  updateProvince,
  createNewProvince,
} from "../../../store/province/provinceActions";
import AddIcon from "@material-ui/icons/Add";
import ManageProvince from "./ManageProvince";
import Container from "@material-ui/core/Container";
import { Fab, Typography } from "@material-ui/core";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.grey[400],
    color: theme.palette.common.white,
    fontSize: 16,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.grey[100],
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  createButton: {
    position: "absolute",
    bottom: theme.spacing(12),
    right: theme.spacing(4),
  },
  tableContainer: {
    maxHeight: 600,
  },
}));

const tableheader = [
  { name: "Code", key: "code", type: "text" },
  { name: "Name", key: "name", type: "text" },
  { name: "Name Ar", key: "name_ar", type: "text" },
  { name: "Enabled", key: "enabled", type: "switch" },
  { name: "Min SLA", key: "min_sla", type: "text" },
  { name: "Max SLA", key: "max_sla", type: "text" },
];

export default function ProvinceListTable(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [state, setState] = React.useState({
    deleteAction: false,
    editAction: false,
    createAction: false,
    selectedItem: null,
    createItem: {
      id: 0,
      code: "",
      name: "",
      name_ar: "",
      enabled: true,
      min_sla: 0,
      max_sla: 0,
    },
  });

  const editRow = (event, data) => {
    event.stopPropagation();
    setState({
      ...state,
      editAction: true,
      deleteAction: false,
      createAction: false,
      selectedItem: data,
    });
  };

  const closeModal = (name) => {
    setState({ ...state, [name]: false });
  };

  const updateProvinceAction = (province) => {
    dispatch(updateProvince(province));
    closeModal("editAction");
  };

  const createProvinceAction = (province) => {
    dispatch(createNewProvince(province));
    closeModal("createAction");
  };

  const openCreateModal = () => {
    setState({
      ...state,
      createAction: true,
      editAction: false,
      deleteAction: false,
    });
  };
  const modalPopUp = () => {
    if (state.deleteAction) {
      return (
        <DeleteModal
          open={state.deleteAction}
          close={() => closeModal("deleteAction")}
          title={state.selectedItem.title}
          deleteConfirmation={props.deleteAPICall}
        />
      );
    } else if (state.editAction) {
      return (
        <ManageProvince
          headerMessage="Update Province/State"
          open={state.editAction}
          close={() => closeModal("editAction")}
          data={state.selectedItem}
          actionHandler={updateProvinceAction}
        />
      );
    } else if (state.createAction) {
      return (
        <ManageProvince
          headerMessage="Add New Province"
          open={state.createAction}
          close={() => closeModal("createAction")}
          data={state.createItem}
          actionHandler={createProvinceAction}
        />
      );
    }
  };

  const tabledoby = ({ selectedWarehouse }) => {
    const lastMileSla = (last_mile_sla) => last_mile_sla?.find(sla => sla.warehouse === selectedWarehouse)
    if (props.tabaledata) {
      return props.tabaledata.map((data) => (
        <StyledTableRow
          key={data.id}
          hover
          onClick={() => props.rowSelected(data)}
          style={{ cursor: 'pointer' }}
        >
          {tableheader.map((cell, index) => {
            const lastMileSlaData = lastMileSla(data.last_mile_sla)
            return (
              <TableCell align="left" key={index}>
                {cell.type === "switch" ? data[cell.key] + "" :
                (cell.key === "min_sla" && lastMileSlaData?.min_sla) ? lastMileSlaData.min_sla
                : (cell.key === "max_sla" && lastMileSlaData?.max_sla) ? lastMileSlaData.max_sla
                : data[cell.key]}
              </TableCell>
            )
          })}

          <TableCell>
            <Fab
              color="default"
              aria-label="edit"
              size="small"
              variant="extended"
              onClick={(event) => editRow(event, data)}
            >
              <EditIcon color="primary" />
            </Fab>
            {/* <DeleteIcon onClick={() => deleteRow(data)} color="secondary" /> */}
          </TableCell>
        </StyledTableRow>
      ));
    } else {
      <div>No data found</div>;
    }
  };

  const selectedWarehouse = localStorage.getItem("warehouse");

  return (
    <React.Fragment>
      <Fab
        color="primary"
        aria-label="add"
        onClick={openCreateModal}
        className={classes.createButton}
        position="absolute"
      >
        <AddIcon />
      </Fab>

      <Container maxWidth="xl">
        <Typography variant="subtitle2" gutterBottom align="left">
          Province/State
        </Typography>
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table
            stickyHeader
            className={classes.table}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow>
                {tableheader.map((row) => (
                  <StyledTableCell align="left" key={row.name}>
                    {row.name}
                  </StyledTableCell>
                ))}
                <StyledTableCell align="left">Action</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>{tabledoby({ selectedWarehouse })}</TableBody>
          </Table>
        </TableContainer>
      </Container>
      {modalPopUp()}
    </React.Fragment>
  );
}
